const t = {
  name: "ThumbUp",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 2H10.3406L7.60035 8.39392C7.44277 8.7616 7.08124 9 6.68121 9H2V22H16.76C17.8929 22 18.9462 21.3605 19.4479 20.3301L19.4497 20.3266L21.5433 16.0893L21.5497 16.0754C23.0627 12.7617 20.6365 9 17 9H15.6813C17.0398 5.74322 14.6727 2 11 2ZM8 20V10.6946C8.6325 10.3849 9.14979 9.85574 9.43864 9.18176L11.6321 4.06361C13.6001 4.46846 14.7144 6.72774 13.6619 8.58352L12.2698 11H17C19.1788 11 20.631 13.2485 19.7362 15.2317L17.6534 19.447L17.6503 19.4534C17.4914 19.7809 17.1458 20 16.76 20H8ZM6 11V20H4V11H6Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ThumbUp
};
